'use strict';

var React = require('react');
var cs = require('classnames');
require('../Box/Box.js');
require('../../style-inject.es-dcee06b6.js');
var components_Icon_Icon = require('../Icon/Icon.js');
require('../../icons/AlertTriangleOutline.js');
require('../../icons/BulbOutline.js');
require('../../icons/CheckmarkOutline.js');
require('../../icons/InfoOutline.js');
require('../../icons/LoaderOutline.js');
var components_Text_Text = require('../Text/Text.js');
var components_ExtraInfo_utils_returnIcon = require('./utils/returnIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cs__default = /*#__PURE__*/_interopDefaultLegacy(cs);

const ExtraInfo = ({ extraInfo, variant = "helper" }) => {
    const icon = components_ExtraInfo_utils_returnIcon.returnIcon(variant);
    const classes = cs__default['default']("ss-mt-2 ss-py-2 ss-px-4 ss-gap-2 ss-rounded-sm ss-flex ss-items-center", {
        "ss-bg-neutral-200 ss-text-neutral-500": variant === "helper",
        "ss-bg-primary2-50 ss-text-error-600": variant === "error" || variant === "password",
        "ss-bg-warning-50 ss-text-warning-600": variant === "warning",
        "ss-bg-success-50 ss-text-success-600": variant === "validated",
        "ss-bg-neutral-100 ss-text-primary1-500": variant === "validating",
    });
    return (React__default['default'].createElement("div", { className: classes },
        icon && React__default['default'].createElement(components_Icon_Icon, { svg: icon, className: "ss-w-4 ss-h-4" }),
        React__default['default'].createElement(components_Text_Text, { variant: "paragraphVerySmall", className: "ss-flex-1" }, extraInfo)));
};

module.exports = ExtraInfo;
